import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { BonusOfferInterface } from "src/app/interfaces/bonus-offer.interface";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { isUndefined } from "src/app/services/codeUtils";
import { ConfigService } from "src/app/services/config/config.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { RewardsService } from "src/app/services/rewards/rewards.service";

@Component({
  selector: 'app-bonus-selector',
  templateUrl: './bonus-selector.component.html',
  styleUrls: ['./bonus-selector.component.scss'],
})

export class BonusSelectorComponent implements OnInit {

  private _selectedBonusCode: string;

  @Input() set selectedBonusCode(value: string) {
    if (this._selectedBonusCode != value) {
      this._selectedBonusCode = value;
      if (value) {
        let index = this.welcomeOffers.findIndex(offer => value === offer.signupcode);
        if (index !== -1) {
          this.selectedBonusIndex = index;
          this.selectedBonusOffer.emit({ bonus: this.welcomeOffers[index].signupcode });
        } else {
          this.selectedBonusIndex = -1;
          this.selectedBonusOffer.emit({ bonus: value });
        }

      }
    } else {
      this._selectedBonusCode = value;
    }
  }
  get selectedBonusCode(): string { return this._selectedBonusCode; }


  @Output() selectedBonusOffer: EventEmitter<any> = new EventEmitter();
  @Output() bonusOffers: EventEmitter<any> = new EventEmitter();

  public bonusCode: any;
  public selectedBonusIndex: number;
  public welcomeOffers: BonusOfferInterface[] = [];

  constructor(
    private appLinksService: AppLinksService,
    private configService: ConfigService,
    private rewardService: RewardsService,
    private successMessageService: SuccessMessageService,
  ) { }

  ngOnInit(): void {
    this.successMessageService.clearMessage();
    this.getBonusOffers();
  }

  public addHiddenOffer(bonus) {
    this.welcomeOffers.unshift(bonus);
  }

  private getBonusOffers() {
    const data: any = {
      clientapp: this.configService.getClientApp()
    };

    this.rewardService.callGetSignupOffers(data).subscribe((response: any) => {
      if (response && !!response.result && !isUndefined(response.payload)) {
        this.welcomeOffers = response?.payload;
        if (!this._selectedBonusCode) {
          const defaultBonusOffer = this.welcomeOffers?.filter(offer => offer?.tagline?.toUpperCase() == 'DEFAULT')[0] || this.welcomeOffers[0];
          this.selectedBonusIndex = this.welcomeOffers?.findIndex(offer => offer?.tagline?.toUpperCase() == 'DEFAULT') || 0;
          this.bonusOffers.emit(this.welcomeOffers);
          this.onBonusSelect(this.selectedBonusIndex, defaultBonusOffer);  
        } else {
          let index = this.welcomeOffers.findIndex(offer => this._selectedBonusCode === offer.signupcode);
          if (index !== -1) {
            this.selectedBonusIndex = index;
            this.selectedBonusOffer.emit({ bonus: this.welcomeOffers[index].signupcode });
            this.onBonusSelect(this.selectedBonusIndex, this.welcomeOffers[index]); 
          }
        }
      }
    }, error => console.error("Get Signup Offer Errors:", error));

  }

  public onBonusSelect(index: number, offer: BonusOfferInterface): any {
    this.bonusCode = offer.signupcode;
    this.selectedBonusIndex = index;

    let obj: { bonus: any } = {
      bonus: this.bonusCode
    }

    return this.selectedBonusOffer.emit(obj);
  }

  public openExternalLinks(url: string, title: string): any {
    return this.appLinksService.openPopover(url, title);
  }

}
